<div *ngIf="useTextEntry; else linkTemplate">
  <mat-card appearance="outlined">
    <mat-card-title>Ask GPS AI</mat-card-title>

    <div class="initial-input-container">
      <form (ngSubmit)="ask()">
        <div>
          <mat-form-field appearance="outline"
                        class="formfield__no-label dark-background flex-fill">
            <input matInput [(ngModel)]="userInput" placeholder="What do you want to know?" name="initialPrompt" autocomplete="off"/>
          </mat-form-field>
        </div>
        <div class="chat-button-wrapper">
          <button type="submit" class="chat-button">Ask Now</button>
        </div>
      </form>
    </div>
  </mat-card>
</div>
<ng-template #linkTemplate>
  <a mat-menu-item [routerLink]="['/chat']" class="ai__open-link "><mat-icon svgIcon="chat"></mat-icon><span>Ask GPS AI</span></a>
</ng-template>
